import { useNavigate } from "react-router-dom";
import { ListFetch } from "../../lib/typeDeclarations";
import { useListRecords } from "../../server/hooks/getData";
import { useFilters } from "../../lib/setSearchParams";

import Header from "../../components/layout/Header";
import { TextInput } from "../../components/inputs/TextInput";
import { FilterBar, Page, PageBody, PageHeader } from "../../components/layout/Page";
import { PrimaryButton } from "../../components/buttons/PrimaryButton";
import { Loader } from "../../components/loader/Loader";
import { addIcon } from "../../assets/icons";

export default function ClientList() {
  document.title = "Ügyfelek";
  const navigate = useNavigate();

  //States
  const { filters, setFilters } = useFilters();
  const headers = ["Ügyfél", "Adószám", "Cím"];

  const { data: clients, loading }: ListFetch = useListRecords(
    "clients",
    [JSON.stringify(filters)],
    {
      ...filters,
      orderBy: "name",
      order: "ASC",
    }
  );

  //Component
  return (
    <Page>
      <Header
        itemCounter={{
          page: clients.page,
          limit: clients.limit,
          total: clients.total,
          setPage: setFilters,
        }}
      >
        <PrimaryButton
          btn={{ svgBefore: addIcon, text: "Létrehozás", onClick: () => navigate("new") }}
        />{" "}
      </Header>
      <PageHeader title="Ügyfelek" />
      <FilterBar>
        <TextInput stateKey="name" placeholder="Név" state={filters} setState={setFilters} />
        <TextInput stateKey="vat" placeholder="Adószám" state={filters} setState={setFilters} />
      </FilterBar>
      {!loading ? (
        <>
          <PageBody>
            <div className="listitem">
              <table>
                <thead>
                  <tr>
                    {headers.map(item => (
                      <th key={item}>{item}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {clients.data.length !== 0 ? (
                    clients.data.map(item => (
                      <tr key={item.id} onClick={() => navigate(`${item.id}`)}>
                        <td>{item.name}</td>
                        <td>{item.vat}</td>
                        <td>{`${item.zip} ${item.city}, ${item.street}`}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={headers.length + 1} style={{ textAlign: "center" }}>
                        Nincs találat!
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </PageBody>
        </>
      ) : (
        <Loader />
      )}
    </Page>
  );
}
